// src/App.js
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './App.css';
import SpotlightCursor from './components/SpotlightCursor';
import Navbar from './components/Navbar';
import { Footer } from './components/Footer';
import HomePage from './pages/HomePage';
import CookieConsent from './components/CookieConsent';
import PricingPage from './pages/PricingPage';
import RewardsPage from './pages/RewardsPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import ResultsPage from './pages/ResultsPage';
import SplashScreen from './components/SplashScreen';
import InsightsPage from './pages/InsightsPage'; // <- new import
import InsightAiCryptoSignalsPage from "./pages/InsightAiCryptoSignalsPage";
import AboutPage from "./pages/AboutPage";
import InsightRiskManagementSmallAccountsPage from "./pages/InsightRiskManagementSmallAccountsPage";
import InsightCryptoSignalsBeginnersPage from "./pages/InsightCryptoSignalsBeginnersPage";
import InsightAiTradingSignalsAndroidPage from "./pages/InsightAiTradingSignalsAndroidPage";
import WhitepaperPage from "./pages/WhitepaperPage";
import TokenPage from "./pages/TgenTokenPage";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setLoading(false), 2200);
    return () => clearTimeout(t);
  }, []);

  if (loading) return <SplashScreen />;

  return (
    <Router>
      <SpotlightCursor />
      <Helmet>
        <title>Trend Genie: AI Powered Investment Analysis App</title>
        <meta
          name="description"
          content="Make smarter trading decisions with Trend Genie. Get real time data, AI powered insights, and advanced charting for stocks and crypto, right on your Android phone."
        />
        <meta
          name="keywords"
          content="investment app, stock market analysis app, AI trading tool, crypto tracker, Trend Genie app"
        />
      </Helmet>

      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/rewards" element={<RewardsPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/live-results" element={<ResultsPage />} />
          <Route path="/insights" element={<InsightsPage />} /> {/* new route */}
          <Route path="/about" element={<AboutPage />} />
          <Route path="/whitepaper" element={<WhitepaperPage />} />
          <Route path="/token" element={<TokenPage />} />

          <Route
  path="/insights/ai-crypto-signals-app-android"
  element={<InsightAiCryptoSignalsPage />}
/>
<Route
  path="/insights/risk-management-small-trading-accounts"
  element={<InsightRiskManagementSmallAccountsPage />}
/>
<Route
  path="/insights/crypto-signals-for-beginners"
  element={<InsightCryptoSignalsBeginnersPage />}
/>
<Route
  path="/insights/ai-trading-signals-android"
  element={<InsightAiTradingSignalsAndroidPage />}
/>
        </Routes>
      </main>
      <Footer />
      <CookieConsent />
    </Router>
  );
}

export default App;
